import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DeliveryDefenseService } from 'app/delivery-defense/services/delivery-defense.service';
import dayjs from 'dayjs';
import { of, Subject, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { UserTermsConditionsComponent } from '../../../account/user-settings/user-terms-conditions/user-terms-conditions.component';
import { AppState } from '../../../app.state';
import { UserRoutes } from '../../../core/models/user-routes.model';
import { AuthenticationService } from '../../../core/services/authentication/authentication.service';
import { UserRouteService } from '../../../core/services/user-routes/user-routes.service';
import { Customer } from '../../models/customer/customer.model';
import { DialogService } from '../../services/dialog/dialog.service';
import { SingleSignOnService } from '../../services/single-sign-on/single-sign-on.service';
import { User } from '../../services/user/models/user.model';
import { UserService } from '../../services/user/user.service';
import { UtilityService } from '../../services/utility/utility.service';
import { ComplaintsComponent } from '../complaints/complaints.component';
import { DisclaimerComponent } from '../disclaimer/disclaimer.component';
import { ImprintComponent } from '../imprint/imprint.component';
import { InternationalProductDisclosureComponent } from '../international-product-disclosure/international-product-disclosure.component';
import { PrivacyDialogComponent } from '../privacy/privacy-dialog/privacy-dialog.component';
import { URLs } from './URL-enum';

@Component({
    selector: 'upsc-side-bar-menu',
    templateUrl: './side-bar-menu.component.html',
    styleUrls: ['./side-bar-menu.component.scss'],
})
export class SideBarMenuComponent implements OnInit, OnDestroy {
    @Output() public notifyToggle: EventEmitter<string> = new EventEmitter<string>();

    public isMenuLoading = false;
    public isSideMenuOpened = false;
    public shipmentHistory = false;
    public isAdmin: boolean;

    public dashboardMenuActive = false;

    public showAccount = false;
    public accountMenuActive = false;

    public showAddressBook = false;
    public addressMenuActive = false;

    public showClaims = false;
    public claimMenuActive = false;

    public showDeliveryDefense = false;
    public deliveryDefenseMenuActive = false;

    public showBilling = false;
    public billingMenuActive = false;

    public showShip = false;
    public shipMenuActive = false;

    public showSupport = false;
    public supportMenuActive = false;

    public showTrack = false;
    public trackMenuActive = false;

    public showRiskMitigation = false;
    public riskMitigationMenuActive = false;

    public showECommerce = false;
    public eCommerceMenuActive = false;

    public user: User;
    public userRoutes: UserRoutes;
    public customer: Customer;
    public currentUser: User;

    public isGB = false;
    public isDE = false;
    public isUS = false;
    public isFR = false;
    public isIT = false;
    public isDDEnabled = false;
    public isLessThanCurrentDate: boolean = false;
    public sessionLanguage: string;
    public subscribedDetails: any;
    public currentSubType = false;
    // public currentSubTypeOther = false;
    public isMonthlyTierValue1 = false;
    public selectedURL: string;
    // public shouldShowTermsOfUse = false;
    public ssoURL = 'https://parcelpro.zendesk.com';
    public currentYear = dayjs().format('YYYY');
    protected readonly environment = environment;
    private isMediaQueryChecked = false;
    private mq = window.matchMedia('(min-width: 64em)');
    private getUserRoutesSubscription: Subscription;
    private ngDestroyed$ = new Subject<void>();

    public get canSignUpDD(): boolean {
        const hasSubType = this.subscribedDetails?.CurrentSubType !== null && this.subscribedDetails?.CurrentSubType !== undefined;
        return (this.appState?.customer$().DDEnabled === false && !hasSubType)
        || (this.appState?.customer$().DDEnabled === true && this.subscribedDetails?.CurrentSubType === 5);
    }

    public constructor(public router: Router,
                       private dialog: MatDialog,
                       private userService: UserService,
                       // private notificationService: NotificationService,
                       private authenticationService: AuthenticationService,
                       // private sharedService: SharedService,
                       private utilityService: UtilityService,
                       private dialogService: DialogService,
                       private translateService: TranslateService,
                       private userRouteService: UserRouteService,
                       private singleSignOnService: SingleSignOnService,
                       private deliveryDefenseService: DeliveryDefenseService,
                       // private storageService: StorageService,
                       @Inject(DOCUMENT) private document: Document,
                       public readonly appState: AppState,
    ) {
        this.setActiveMenu();
        this.userService.getCurrentUser().subscribe(
            (currentUser) => {
                this.currentUser = currentUser;
                this.isAdmin = currentUser ? currentUser.isAdmin : false;
            },
        );

        this.user = this.appState.user$();
        this.customer = this.appState.customer$();
        this.userRoutes = this.appState.userRoutes$();

        if (!this.userRoutes) {
            this.userRoutes = this.userRouteService.loadUserRoutes(this.user, this.customer);
            this.appState.userRoutes$.set(this.userRoutes);
        }

        this.isDDEnabled = this.customer?.DDEnabled === true;
        this.isMonthlyTierValue1 = this.customer?.MonthlyTierType === 5;

        this.deliveryDefenseService.getSubscriberDetails()
            .pipe(
                catchError((err) => {
                    console.error(err);
                    return of(null);
                }),
            )
            .subscribe((response) => {
                this.subscribedDetails = response;

                //temporarily showing sign up page for  this.subscribedDetails?.CurrentSubType === 0
                this.currentSubType = this.subscribedDetails?.CurrentSubType === 5 || this.subscribedDetails?.CurrentSubType === null;

                this.isLessThanCurrentDate = dayjs(this.subscribedDetails?.CurrentSubEndDate).isValid()
                    ? dayjs().isAfter(this.subscribedDetails?.CurrentSubEndDate)
                    : true;

                // const currentDate = new Date();
                // const dateString = this.subscribedDetails?.CurrentSubEndDate;
                // const date: moment.Moment = moment(dateString);
                // if (dateString !== null) {
                //     if (date.isBefore(currentDate)) {
                //         this.isLessThanCurrentDate = true;
                //     }
                // } else {
                //     this.isLessThanCurrentDate = true;
                // }
            });

        /*
                this.isGB = this.utilityService.getDomain().toLowerCase() === 'en-gb' || this.user.CountryCode === 'GB';
                this.isUS = this.utilityService.getDomain().toLowerCase() === 'en';
                this.isDE = this.utilityService.getDomain().toLowerCase() === 'de';
                this.isIT = this.utilityService.getDomain().toLowerCase() === 'it';
                this.isFR = this.utilityService.getDomain().toLowerCase() === 'fr';
        */

        this.isGB = this.user.CountryCode.toLowerCase() === 'gb';
        this.isUS = this.user.CountryCode.toLowerCase() === 'us';
        this.isDE = this.user.CountryCode.toLowerCase() === 'de';
        this.isIT = this.user.CountryCode.toLowerCase() === 'it';
        this.isFR = this.user.CountryCode.toLowerCase() === 'fr';
    }

    public get isOfficialDDSubscriber(): boolean {
        if (this.subscribedDetails?.CurrentSubType === null) {
            return false;
        }

        const isTrailDDSubscriber = this.subscribedDetails?.CurrentSubType === 5;
        return !isTrailDDSubscriber;
    }

    public ngOnInit(): void {
        if (this.mq.matches && !this.isMediaQueryChecked) {
            this.isMediaQueryChecked = true;
            this.isSideMenuOpened = true;
            this.notifyToggle.emit('toggled');
            this.generateSupportLink(null);
        }
    }

    public ngOnDestroy(): void {
        this.ngDestroyed$.next();
        this.ngDestroyed$.complete();

        this.userRoutes = null;
        this.utilityService.clearSubscriptions([this.getUserRoutesSubscription]);
    }

    public ToggleClass(): void {
        const wrapper = document.getElementById('wrapper');
        wrapper.classList.toggle('toggled');
        this.toggleMenu();
    }

    public toggleMenu(): void {
        this.isSideMenuOpened = !this.isSideMenuOpened;

        /* Collapse all menu options when a user closes the menu */
        if (!this.isSideMenuOpened) {
            this.resetMenu();
        }

        const bodyEl = document.getElementsByTagName('body')[0];
        if (this.isSideMenuOpened) {
            bodyEl.classList.add('noscroll');
        } else {
            bodyEl.classList.remove('noscroll');
        }
    }

    public ExpandHamburgerMenu(): void {
        const wrapper = document.getElementById('wrapper');
        wrapper.classList.add('toggled');

        this.isSideMenuOpened = true;
    }

    public setActiveMenu(): void {
        const pathFragments = this.router.url?.split('/')?.filter(fragment => fragment !== '');
        const category = pathFragments[0];

        if (!category) {
            this.dashboardMenuActive = true;
            return;
        }

        switch (category) {
            case 'dashboard':
                this.dashboardMenuActive = true;
                break;
            case 'track-shipments':
            case 'shipment-history':
            case 'report-history':
            case 'schedule-pickups':
            case 'package-investigation':
            case 'end-of-day-reports':
                this.trackMenuActive = true;
                this.showTrack = this.mq.matches;
                break;
            case 'claims':
                this.riskMitigationMenuActive = true;
                this.showRiskMitigation = this.mq.matches;
                break;
            case 'user-settings':
            case 'company-profile':
            case 'manage-users':
            case 'rewardship':
            case 'dw-rewardship':
            case 'notify-templates':
                this.accountMenuActive = true;
                this.showAccount = this.mq.matches;
                break;
            case 'address-book':
            case 'manage-locations':
                this.addressMenuActive = true;
                this.showAddressBook = this.mq.matches;
                break;
            case 'delivery-defense-sign-up':
            case 'address-confidence-tool':
            case 'score-history':
            case 'shipping-intelligence':
            case 'manage-subscription':
            case 'delivery-defense-faq':
                this.deliveryDefenseMenuActive = true;
                this.showDeliveryDefense = this.mq.matches;
                break;

            case 'billing-history':
            case 'payment-history':
            case 'manage-credit-card':
            case 'credit-history':
                this.billingMenuActive = true;
                this.showBilling = this.mq.matches;
                break;

            case 'supply-order':
            case 'restricted-zip-codes':
            case 'support-documents':
            case 'support/contact-us':
                this.supportMenuActive = true;
                this.showSupport = this.mq.matches;
                break;

            case 'world-ship-upload':
            case '/ship':
            case 'pending-shipments':
            case 'report-shipments':
            case 'saved-quotes':
            case 'cost-estimator':
            case 'return-shipment':
                this.shipMenuActive = true;
                this.showShip = this.mq.matches;
                break;

            case 'e-commerce':
                this.eCommerceMenuActive = true;
                this.showECommerce = this.mq.matches;
                break;
            default:
                break;
        }
    }

    //#region Events

    public ShowTrack(): void {
        this.showTrack = !this.showTrack;
        this.ExpandHamburgerMenu();
    }

    public ShowRiskMitigation(): void {
        this.showRiskMitigation = !this.showRiskMitigation;
        this.ExpandHamburgerMenu();
    }

    public ShowAccount(): void {
        this.showAccount = !this.showAccount;
        this.ExpandHamburgerMenu();
    }

    public ShowBilling(): void {
        this.showBilling = !this.showBilling;
        this.ExpandHamburgerMenu();
    }

    public ShowDeliverDefense(): void {
        this.showDeliveryDefense = !this.showDeliveryDefense;
        this.ExpandHamburgerMenu();
    }

    public ShowSupport(event: MouseEvent): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.showSupport = !this.showSupport;
        this.ExpandHamburgerMenu();
    }

    public ShowShip(event): void {
        event.preventDefault();
        this.showShip = !this.showShip;
        this.ExpandHamburgerMenu();
    }

    public ShowAddressBook(event): void {
        event.preventDefault();
        this.showAddressBook = !this.showAddressBook;
        this.ExpandHamburgerMenu();
    }

    public ShowClaims(event): void {
        event.preventDefault();
        this.showClaims = !this.showClaims;
        this.ExpandHamburgerMenu();
    }

    public toggleECommerceMenu(event: MouseEvent): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.showECommerce = !this.showECommerce;
        this.ExpandHamburgerMenu();
    }

    public logout(event): void {
        event.preventDefault();

        this.dialogService.confirm('', this.translateService.instant('logoutConfirmation'), 'dialog-center')
            .subscribe(
                (result) => {
                    if (!result) {
                        return;
                    }

                    this.authenticationService.logout();
                },
            );
    }

    public resetMenu(): void {
        this.showTrack = false;
        this.shipmentHistory = false;
        this.showAccount = false;
        this.showBilling = false;
        this.showDeliveryDefense = false;
        this.showSupport = false;
        this.showShip = false;
        this.showAddressBook = false;
        this.showECommerce = false;
        this.showClaims = false;
        this.showRiskMitigation = false;
    }

    public showShipNav(): boolean {
        return this.userRoutes?.ShipUPS
            || this.userRoutes?.ShipUPS
            || this.userRoutes?.ShipReport
            || this.userRoutes?.RecentShipment
            || this.userRoutes?.SavedQuotes;
    }

    public showTrackNav(): boolean {
        return this.userRoutes?.ShipmentHistory
            || this.userRoutes?.ReportHistory
            || this.userRoutes?.SchedulePickup
            || this.userRoutes?.PackageInvestigation
            || this.userRoutes?.EndOfDayReports;
    }

    public showRiskMitigationNav(): boolean {
        return this.userRoutes?.Claims
            || this.showDeliveryDefenseNav();
    }

    public showDeliveryDefenseNav(): boolean {
        return this.userRoutes?.DeliveryDefenseFAQ
            || this.userRoutes?.DeliveryDefenseSignUp
            || this.userRoutes?.ShippingIntelligence
            || this.userRoutes?.ManageSubscriptions
            || this.userRoutes?.AddressConfidenceTool
            || this.userRoutes?.ScoreHistory;
    }

    public showBillingNav(): boolean {
        return this.userRoutes?.BillingHistory
            || this.userRoutes?.PaymentHistory
            || this.userRoutes?.ManageCreditCard
            || this.userRoutes?.CreditHistory;
    }

    public showAddressBookNav(): boolean {
        return this.userRoutes?.AddressBook || this.userRoutes?.ManageLocations;
    }

    public showClaimsNav(): boolean {
        return this.userRoutes?.Claims;
    }

    public showAccountNav(): boolean {
        return this.userRoutes?.UserSettings
            || this.userRoutes?.CompanyProfile
            || this.userRoutes?.ManageUsers
            || this.userRoutes?.DWRewardShip
            || this.userRoutes?.RewardShip
            || this.userRoutes?.NotifyTemplates;
    }

    public showSupportNav(): boolean {
        return this.userRoutes?.SupplyOrder
            || this.userRoutes?.RestrictedZipCodes
            || this.userRoutes?.ContactUs;
    }

    public getCurrentYear(): number {
        return (new Date()).getFullYear();
    }

    public openTermsAndConditionsDialog(event): void {
        event.preventDefault();

        const dialogConfig: MatDialogConfig = {
            disableClose: true,
            width: '70%',
            data: {},
        };

        const dialogRef = this.dialog.open(UserTermsConditionsComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((result) => {
        });
    }

    public openPrivacyDialog(event): void {
        event.preventDefault();

        const dialogConfig: MatDialogConfig = {
            disableClose: true,
            width: '70%',
        };

        const dialogRef = this.dialog.open(PrivacyDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((result) => {
        });
    }

    public generateSupportLink(event: MouseEvent, ssoForm: any = null): void {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        // TODO: generate GLIA link for US customers on US site.
        this.singleSignOnService.generateSSOToken().subscribe(
            response => this.returnZendeskURL(response, ssoForm),
            err => this.handleZendeskFailure(err),
        );
    }

    public isDEGBUser(): boolean {
        return this.user.CustomerId.substring(0, 2) === 'GB' || this.user.CustomerId.substring(0, 2) === 'DE';
    }

    public isDEUser(): boolean {
        return this.user.CustomerId.substring(0, 2) === 'DE';
    }

    public isGBUser(): boolean {
        return this.user.CustomerId.substring(0, 2) === 'GB';
    }

    public isEUUser(): boolean {
        return this.userService.isUserEU(this.user);
    }

    public openComplaintsDialog(event: MouseEvent): void {
        event.preventDefault();

        const dialogConfig: MatDialogConfig = {
            disableClose: true,
            width: '70%',
            data: {},
        };

        const dialogRef = this.dialog.open(ComplaintsComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((result) => {
        });
    }

    public websiteTermsOfUse(event: MouseEvent): void {
        event.preventDefault();
        const websiteTermsOfUseUrls = {
            IT: { it: URLs.WebSiteTermofUseITIT, en: URLs.WebSiteTermofUseITEN },
            FR: { fr: URLs.WebSiteTermofUseFRFR, en: URLs.WebSiteTermofUseFREN },
            DE: { de: URLs.WebSiteTermofUseDEDE, en: URLs.WebSiteTermofUseDEEN },
        };
        this.sessionLanguage = sessionStorage.getItem('lang');
        switch (true) {
            case this.isIT === true:
                this.selectedURL = websiteTermsOfUseUrls.IT[this.sessionLanguage];
                break;
            case this.isFR === true:
                this.selectedURL = websiteTermsOfUseUrls.FR[this.sessionLanguage];
                break;
            case this.isDE === true:
                this.selectedURL = websiteTermsOfUseUrls.DE[this.sessionLanguage];
                break;
            default:
                break;
        }

        window.open(this.selectedURL, '_blank');
    }

    public technologyAgreement(event: MouseEvent): void {
        event.preventDefault();
        const technologyAgreementUrls = {
            IT: { it: URLs.TechnologyAgreementITIT, en: URLs.TechnologyAgreementITEN },
            FR: { fr: URLs.TechnologyAgreementFRFR, en: URLs.TechnologyAgreementFREN },
            DE: { de: URLs.TechnologyAgreementDEDE, en: URLs.TechnologyAgreementDEEN },
        };
        this.sessionLanguage = sessionStorage.getItem('lang');
        switch (true) {
            case this.isIT === true:
                this.selectedURL = technologyAgreementUrls.IT[this.sessionLanguage];
                break;
            case this.isFR === true:
                this.selectedURL = technologyAgreementUrls.FR[this.sessionLanguage];
                break;
            case this.isDE === true:
                this.selectedURL = technologyAgreementUrls.DE[this.sessionLanguage];
                break;
            default:
                break;
        }

        window.open(this.selectedURL, '_blank');
    }

    public internationalProductDisclosure(event: MouseEvent): void {
        event.preventDefault();
        const productDisclosureUrls = {
            IT: { it: URLs.ProductDisclosureITIT, en: URLs.ProductDisclosureITEN },
            FR: { fr: URLs.ProductDisclosureFRFR, en: URLs.ProductDisclosureFREN },
            DE: { de: URLs.ProductDisclosureDEDE, en: URLs.ProductDisclosureDEEN },
            GB: { en: URLs.ProductDisclosureGBEN },
        };
        this.sessionLanguage = sessionStorage.getItem('lang');
        switch (true) {
            case this.isIT === true:
                this.selectedURL = productDisclosureUrls.IT[this.sessionLanguage];
                break;
            case this.isFR === true:
                this.selectedURL = productDisclosureUrls.FR[this.sessionLanguage];
                break;
            case this.isDE === true:
                this.selectedURL = productDisclosureUrls.DE[this.sessionLanguage];
                break;
            case this.isGB === true:
                this.selectedURL = URLs.ProductDisclosureGBEN;
                break;
            default:
                break;
        }

        window.open(this.selectedURL, '_blank');
    }

    public complaints(event: MouseEvent): void {
        event.preventDefault();
        const complaintsUrls = {
            IT: { it: URLs.ComplaintsITIT, en: URLs.ComplaintsITEN },
            FR: { fr: URLs.ComplaintsFRFR, en: URLs.ComplaintsFREN },
            DE: { de: URLs.ComplaintsDEDE, en: URLs.ComplaintsDEEN },
        };
        this.sessionLanguage = sessionStorage.getItem('lang');
        switch (true) {
            case this.isIT === true:
                this.selectedURL = complaintsUrls.IT[this.sessionLanguage];
                break;
            case this.isFR === true:
                this.selectedURL = complaintsUrls.FR[this.sessionLanguage];
                break;
            case this.isDE === true:
                this.selectedURL = complaintsUrls.DE[this.sessionLanguage];
                break;
            default:
                break;
        }

        window.open(this.selectedURL, '_blank');
    }

    public impressum(event: MouseEvent): void {
        event.preventDefault();
        this.sessionLanguage = sessionStorage.getItem('lang');
        window.open(
            (this.sessionLanguage === 'en' ?
                URLs.ImpressumEN :
                URLs.ImpressumDE), '_blank');
    }

    public privacy(event: MouseEvent): void {
        event.preventDefault();
        const privacyUrls = {
            IT: { it: URLs.PrivacyNoticeITIT, en: URLs.PrivacyNoticeITEN },
            FR: { fr: URLs.PrivacyNoticeFRFR, en: URLs.PrivacyNoticeFREN },
            DE: { de: URLs.PrivacyNoticeDEDE, en: URLs.PrivacyNoticeDEEN },
        };
        this.sessionLanguage = sessionStorage.getItem('lang');
        switch (true) {
            case this.isIT === true:
                this.selectedURL = privacyUrls.IT[this.sessionLanguage];
                break;
            case this.isFR === true:
                this.selectedURL = privacyUrls.FR[this.sessionLanguage];
                break;
            case this.isDE === true:
                this.selectedURL = privacyUrls.DE[this.sessionLanguage];
                break;
            default:
                break;
        }

        window.open(this.selectedURL, '_blank');
    }

    public showConsentPreferences(): void {
        let language: string;

        this.sessionLanguage = sessionStorage.getItem('lang');
        switch (this.sessionLanguage) {
            case 'en':
                language = 'en-gb';
                break;
            case 'de':
                language = 'de-de';
                break;
            case 'fr':
                language = 'fr-fr';
                break;
            case 'it':
                language = 'it-it';
                break;
            default:
                language = 'en-us';
                break;
        }

        utag.gdpr.showConsentPreferences(language);
        window.scrollTo(0, 0);
    }

    public openComplaintsURL(event: MouseEvent): void {
        event.preventDefault();
        this.sessionLanguage = sessionStorage.getItem('lang');
        window.open(((this.isGB && this.sessionLanguage === 'en-gb') ?
            URLs.ComplaintsGBEN :
            (this.sessionLanguage === 'en' ?
                URLs.ComplaintsDEEN :
                URLs.ComplaintsDEDE)), '_blank');
    }

    public openProductDisclosureURL(event: MouseEvent): void {
        event.preventDefault();
        const productDisclosureUrls = {
            IT: { it: URLs.ProductDisclosureITIT, en: URLs.ProductDisclosureITEN },
            FR: { fr: URLs.ProductDisclosureFRFR, en: URLs.ProductDisclosureFREN },
            DE: { de: URLs.ProductDisclosureDEDE, en: URLs.ProductDisclosureDEEN },
            GB: { en: URLs.ProductDisclosureGBEN },
        };
        this.sessionLanguage = sessionStorage.getItem('lang');
        switch (true) {
            case this.isIT === true:
                this.selectedURL = productDisclosureUrls.IT[this.sessionLanguage];
                break;
            case this.isFR === true:
                this.selectedURL = productDisclosureUrls.FR[this.sessionLanguage];
                break;
            case this.isDE === true:
                this.selectedURL = productDisclosureUrls.FR[this.sessionLanguage];
                break;
            case this.isGB === true:
                this.selectedURL = URLs.ProductDisclosureGBEN;
                break;
            default:
                break;
        }
        window.open(this.selectedURL, '_blank');
    }

    public openWebsiteTermURL(event: MouseEvent): void {
        event.preventDefault();
        this.sessionLanguage = sessionStorage.getItem('lang');
        window.open(((this.isGB && this.sessionLanguage === 'en-gb') ?
            URLs.WebSiteTermGBEN :
            (this.sessionLanguage === 'en' ?
                URLs.WebSiteTermDEEN :
                URLs.WebSiteTermDEDE)), '_blank');
    }

    public openLegalNoticeURL(event: MouseEvent): void {
        event.preventDefault();
        this.sessionLanguage = sessionStorage.getItem('lang');
        window.open(this.sessionLanguage === 'en' ? URLs.LegalNoticeDEEN : URLs.LegalNoticeDEDE, '_blank');
    }

    public openPrivacyNoticeURL(event: MouseEvent): void {
        event.preventDefault();
        this.sessionLanguage = sessionStorage.getItem('lang');
        window.open(((this.isGB && this.sessionLanguage === 'en-gb') ?
            URLs.PrivacyNoticeGBEN :
            (this.sessionLanguage === 'en' ?
                URLs.PrivacyNoticeDEEN :
                URLs.PrivacyNoticeDEDE)), '_blank');
    }

    public openImprintDialog(event: MouseEvent): void {
        event.preventDefault();

        const dialogConfig: MatDialogConfig = {
            disableClose: true,
            width: '70%',
            data: {},
        };

        const dialogRef = this.dialog.open(ImprintComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((result) => {
        });
    }

    public openDisclaimerDialog(event: MouseEvent): void {
        event.preventDefault();

        const dialogConfig: MatDialogConfig = {
            disableClose: true,
            width: '70%',
            data: {},
        };

        const dialogRef = this.dialog.open(DisclaimerComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((result) => {
        });
    }

    public openInternationalProductDisclosureDialog(event: MouseEvent): void {
        event.preventDefault();

        const dialogConfig: MatDialogConfig = {
            disableClose: true,
            width: '70%',
            data: {},
        };

        const dialogRef = this.dialog.open(InternationalProductDisclosureComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((result) => {
        });
    }

    public isLangFrench(): boolean {
        return this.user?.CountryCode === 'FR';
    }

    private returnZendeskURL(res: any, ssoForm: any): void {
        this.ssoURL = res.hcURL;
        ssoForm?.submit();
    }

    private handleZendeskFailure(err: any): void {
        this.ssoURL = 'https://www.parcelpro.com';
    }
}
